export default __webpack_public_path__ + "static/media/sendMessageDisableIcon.4d77ac68.svg";